import { RoutesManager } from "./Routes/routes";

function App() {
  return <RoutesManager />
}

export default App;
